<forge-list-item (click)="fireOnClick()" ng-aria-disable (keyup)="navItemKeyup($event)" class="setup-item"
                 [ngClass]="selectedClass" (contextmenu)="contextMenu($event)" [dense]="compactMode" role="">
    <button type="button" [disabled]="disabled">
        <div class="forge-menu-expansion--child" fxLayout="row" fxLayoutAlign="space-between center">
            <truncate-text [mainText]="name"></truncate-text>
            <forge-icon *ngIf="hasError" name="error_outline" class="error-red">error_outline</forge-icon>
        </div>
    </button>
</forge-list-item>
